import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  realtimeTripsReducer,
  realtimeSpeedReducer
} from "./reducers/RealTimeDataSlice";
import {
  routeDetailsReducer,
  stopDetailsReducer,
  routeNamesReducer,
} from "./reducers/GTFSDataSlice";
import {
  userListReducer,
  userDeleteReducer,
} from "./reducers/UserReducers";

import themeReducer from "./reducers/ThemeSlice";
import paramReducer from "./reducers/ParamSlice";
import realtimeReducer from "./reducers/RealTimeParamSlice";
import langReducer from "./reducers/LangSlice";

const createRootReducer = () =>
  combineReducers({
    userList: userListReducer,
    userDelete: userDeleteReducer,
    theme: themeReducer,
    param: paramReducer,
    realtime: realtimeReducer,
    lang: langReducer,
    realtimeTrips: realtimeTripsReducer,
    realtimeSpeed: realtimeSpeedReducer,
    routeDetails: routeDetailsReducer,
    stopDetails: stopDetailsReducer,
    routeNames: routeNamesReducer,
  });

const createAppStore = () =>
  configureStore({
    middleware: (gdm) =>
      gdm({ immutableCheck: false, serializableCheck: false }),
    preloadedState: {},
    reducer: createRootReducer(),
  });

const store = window.__APP_STORE__ || createAppStore();
if (process.env.NODE_ENV !== 'production') {
  window.__APP_STORE__ = store;
}

if (process.env.NODE_ENV !== 'production' && module && module.hot) {
  module.hot.accept(
    [
      './reducers/ThemeSlice',
      './reducers/ParamSlice',
      './reducers/RealTimeParamSlice',
      './reducers/UserReducers',
      './reducers/LangSlice',
      './reducers/RealTimeDataSlice',
      './reducers/GTFSDataSlice',
    ],
    () => {
      store.replaceReducer(createRootReducer());
    }
  );
}

export default store;
